var exports = {};
exports.isClean = Symbol("isClean");
exports.my = Symbol("my");
export default exports;
export const isClean = exports.isClean,
  my = exports.my;